<template>
  <el-table-column
    prop="file"
    sortable="custom"
    label="Fájl"
    show-overflow-tooltip
    min-width="180"
    show-tooltip-when-overflow
  >
    <template slot-scope="scope">
      <Download
        :id="scope.row.id"
        :name="scope.row.base_filename"
        :file-available="scope.row.file_available"
      />
    </template>
  </el-table-column>
</template>

<script>
import Download from '../Download'
export default {
  components: {
    Download
  },

  propName: 'file',
};
</script>
